import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout, Row, Col, Spin, Card, Select, Button, DatePicker } from "antd";
import { useEffect, useState } from "react";

const { Content } = Layout;
const Option = Select.Option;
const ButtonGroup = Button.Group;

const ItemActionsReport = () => {
  const history = useHistory();
  const hotels = useSelector((state) => state.auth.hotels ?? []);

  const [hotelsOptions, setHotelsOptions] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [dateOptions, setDateOptions] = useState([]);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);

    // HOTELS
    var enabledHotels = [];
    for (var i in hotels) {
      enabledHotels.push(<Option key={i}>{hotels[i]}</Option>);
    }
    setHotelsOptions(enabledHotels);

    // DAYS
    const today = new Date();
    const upperLimit = getUpperDateLimit(today);

    var days = [];
    days.push(<Option key={upperLimit}>{today.toDateString()}</Option>);

    var dayDecrement = today;
    for (i = 0; i < 60; i++) {
      dayDecrement.setDate(dayDecrement.getDate() - 1);
      days.push(
        <Option key={dayDecrement.getTime()}>
          {dayDecrement.toDateString()}
        </Option>
      );
    }

    setDateOptions(days);
    setLoading(false);
  };

  const getUpperDateLimit = (date) => {
    var tomorrow = date;
    tomorrow.setHours(23);
    tomorrow.setMinutes(59);
    tomorrow.setSeconds(59);
    tomorrow.setMilliseconds(999);

    return tomorrow.getTime();
  };

  const setDate = (type, dateString) => {
    const beautifiedDate = dateString.split("-").join("");
    const year = parseInt(beautifiedDate.substring(0, 4), 10);
    const month = parseInt(beautifiedDate.substring(4, 6), 10) - 1;
    const day = parseInt(beautifiedDate.substring(6, 8), 10);

    if (type === "from") {
      const fromTimestamp = new Date(year, month, day, 0, 0, 0, 0).getTime();
      setSelectedFromDate(fromTimestamp);
    }

    if (type === "to") {
      const toTimestamp = new Date(year, month, day, 23, 59, 59, 999).getTime();
      setSelectedToDate(toTimestamp);
    }
  };

  const goToItemActionsReport = () => {
    history.push(
      "/app/reports/itemactionsreport/" +
        selectedHotel +
        "/" +
        selectedFromDate +
        "/" +
        selectedToDate
    );
  };

  return (
    <Layout>
      <Content style={{ margin: 0, padding: 0, background: "#fff" }}>
        <Spin spinning={loading} size="large">
          <Card
            loading={false}
            bordered={false}
            title="Reporte de cantidades - Artículos"
          >
            <Row style={{ marginTop: 30 }}>
              <Col span={4} offset={2}>
                <p>Hotel:</p>
              </Col>
              <Col span={10} offset={2}>
                <Select
                  onChange={(e) => setSelectedHotel(e)}
                  style={{ width: "100%" }}
                >
                  {hotelsOptions}
                </Select>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4} offset={2}>
                <p>Fecha inicial:</p>
              </Col>
              <Col span={10} offset={2}>
                <DatePicker
                  onChange={(_, dateString) => setDate("from", dateString)}
                  disabled={!selectedHotel}
                  placeholder="Selecciona una fecha inicial"
                  format="YYYY-MM-DD"
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4} offset={2}>
                <p>Fecha final:</p>
              </Col>
              <Col span={10} offset={2}>
                <DatePicker
                  onChange={(_, dateString) => setDate("to", dateString)}
                  disabled={!selectedHotel}
                  placeholder="Selecciona una fecha final"
                  format="YYYY-MM-DD"
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 40 }}>
              <Col span={20} offset={2}>
                <ButtonGroup>
                  <Button
                    type="primary"
                    onClick={() => goToItemActionsReport()}
                    disabled={
                      !selectedHotel ||
                      !selectedFromDate ||
                      !selectedToDate ||
                      selectedFromDate > selectedToDate
                    }
                  >
                    Ver reporte
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        </Spin>
      </Content>
    </Layout>
  );
};

export default ItemActionsReport;
